module.exports = __webpack_public_path__ + "img/unhappy.ff8b33b4.png";